import axiosInterceptorInstance from "../../../../utils/axios.interceptor";

export const fetchPlanNames = async (signal: AbortSignal) => {
  const res = await axiosInterceptorInstance.get(`/dashboard/ThmPlanName`, {
    signal,
  });
  return JSON.parse(res.data.body)?.Data || [];
};

export const fetchCohortReport = async (payload: any, signal: AbortSignal) => {
  const res = await axiosInterceptorInstance.post(
    `/dashboard/CohortReport`,
    payload,
    { signal }
  );
  return JSON.parse(res.data.body)?.Data || [];
};
